import { useField, useFormikContext } from 'formik';

import { PortMessage } from '../../../types/PortMessage';

import { PortDetailSelect, PortOption, PortDetailSelectProps } from './PortDetailSelect';

interface FormikPortDetailSelectProps extends Omit<PortDetailSelectProps, 'onChange' | 'value'> {
    name: string;
    onSelect?: (port: PortMessage, scheduleRank?: number) => void;
}

export const FormikPortDetailSelect = (props: FormikPortDetailSelectProps) => {
    const [field, meta, helpers] = useField(props.name);
    const { validateOnChange } = useFormikContext();

    const onChange = (option: PortOption | null, scheduleRank?: number) => {
        helpers.setValue(option ? option.port.id : undefined);
        if (option) {
            props.onSelect?.(option.port, scheduleRank);

            if (!validateOnChange && meta.error) {
                helpers.setError(undefined);
            }
        }
    };

    return (
        <PortDetailSelect
            {...props}
            value={field.value}
            onChange={onChange}
            negative={meta.touched && !!meta.error}
            caption={meta.touched && meta.error ? meta.error : ''}
            onBlur={() => helpers.setTouched(true)}
        />
    );
};
